module.exports = __webpack_public_path__ + "static/media/pointing-right-stretched-white-outline.4a92076b.svg";